// Configurações de navegação
export const NAVIGATION_CONFIG = [
  {
    title: "Plano",
    route: "/planning",
    iconName: "Target"
  },
  {
    title: "Lançar",
    route: "/records",
    iconName: "FileText"
  },
  {
    title: "Análise",
    route: "/dashboard",
    iconName: "TrendingUp"
  },
  {
    title: "Cofrinhos",
    route: "/piggy-banks",
    iconName: "PiggyBank"
  },
  {
    title: "Ajustes",
    route: "/settings",
    iconName: "Settings"
  }
];

// Configuração de navegação mobile (3 itens principais)
export const MOBILE_NAVIGATION_CONFIG = NAVIGATION_CONFIG.slice(0, 3);

// Itens adicionais para o menu "Mais"
export const MORE_MENU_ITEMS = NAVIGATION_CONFIG.slice(3);

// Configurações gerais do app
export const APP_CONFIG = {
  name: "Bufunfa",
  slogan: "Planejou, deu bom!",
  version: "0.1.0",
  defaultCurrency: "BRL",
  dateFormat: "dd/MM/yyyy",
  currencyFormat: {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2
  }
};

// Meses do ano (índice 0-11 para corresponder ao getMonth())
export const MONTHS = [
  { value: 0, label: "Janeiro" },
  { value: 1, label: "Fevereiro" },
  { value: 2, label: "Março" },
  { value: 3, label: "Abril" },
  { value: 4, label: "Maio" },
  { value: 5, label: "Junho" },
  { value: 6, label: "Julho" },
  { value: 7, label: "Agosto" },
  { value: 8, label: "Setembro" },
  { value: 9, label: "Outubro" },
  { value: 10, label: "Novembro" },
  { value: 11, label: "Dezembro" }
];

// Configuração dos botões flutuantes
export const FLOATING_ACTIONS = [
  {
    label: "Nova Receita",
    route: "/add-income",
    iconName: "ArrowUpCircle",
    variant: "default"
  },
  {
    label: "Nova Despesa",
    route: "/add-expense",
    iconName: "ArrowDownCircle",
    variant: "destructive"
  }
];
